import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { color } from "metabase/lib/colors";
import Button from "metabase/core/components/Button";
import {
  shrinkOrExpandOnClick,
  shrinkOrExpandDuration
} from "metabase/styled-components/theme/button";
export const QuestionActionsContainer = styled.div`
  border-left: 1px solid ${color("border")};
  margin-left: 1rem;
  padding-left: 0.5rem;

  ${Button.Root} {
    margin-left: 0.5rem;
  }
`;
export const PopoverContainer = styled.div`
  padding: 1rem;
  min-width: 260px;

  ${Button} {
    width: 100%;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  ${Button.Content} {
    justify-content: flex-start;
  }

  ${Button.TextContainer} {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;
export const BookmarkButton = styled(Button)`
  ${shrinkOrExpandOnClick}

  ${(props) => props.animation === "expand" && css`
      animation: expand linear ${shrinkOrExpandDuration};
    `}

  ${(props) => props.animation === "shrink" && css`
      animation: shrink linear ${shrinkOrExpandDuration};
    `}

      &:hover {
        color: ${(props) => props.isBookmarked ? color("brand") : color("text-dark")};
      }
  }
`;
